module.exports = __webpack_public_path__ + "img/city4.23f061e0.jpg";